import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { IconButton, makeStyles } from '@material-ui/core';
import { DeleteRounded as DeleteIcon } from '@material-ui/icons';

import { DeliveryPoint } from '../../../delivery-points/types/delivery-point.type';
import { DeliveryPointSearchTable } from '../../../delivery-points/components/Tables/DeliveryPointSearchTable.component';
import { CreateOrganizationFormValues } from './create-organization-form.type';

type Props = {
  watch: UseFormWatch<CreateOrganizationFormValues>;
  setValue: UseFormSetValue<CreateOrganizationFormValues>;
};

const useStyles = makeStyles({
  selectedDeliveryPoints: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginTop: '0.5rem',

    '& > h4': {
      margin: 0,
      opacity: 0.7,
    },
  },
  deliveryPointChip: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.25rem 0.5rem',
    borderRadius: 4,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
});

export function DeliveryPointsStep({ watch, setValue }: Props) {
  const classes = useStyles();
  const selectedDeliveryPoints = watch('selectedDeliveryPoints');
  const selectedDeliveryPointIds = selectedDeliveryPoints.map((deliveryPoint) => deliveryPoint.id);

  const handleAddDeliveryPoint = (deliveryPoint: DeliveryPoint) => {
    if (selectedDeliveryPointIds.includes(deliveryPoint.id)) return;
    setValue('selectedDeliveryPoints', [...selectedDeliveryPoints, deliveryPoint]);
  };

  const handleRemoveDeliveryPoint = (deliveryPointId: string) => {
    setValue(
      'selectedDeliveryPoints',
      selectedDeliveryPoints.filter((deliveryPoint) => deliveryPoint.id !== deliveryPointId)
    );
  };

  return (
    <>
      <DeliveryPointSearchTable
        selectedDeliveryPointIds={selectedDeliveryPointIds}
        onAddDeliveryPoint={handleAddDeliveryPoint}
        maxHeight="30svh"
      />
      {selectedDeliveryPoints.length > 0 && (
        <section className={classes.selectedDeliveryPoints}>
          <h4>
            {selectedDeliveryPoints.length} point{selectedDeliveryPoints.length > 1 ? 's' : ''} de livraison
            s&eacute;lectionn&eacute;{selectedDeliveryPoints.length > 1 ? 's' : ''}
          </h4>
          {selectedDeliveryPoints.map((deliveryPoint) => (
            <div key={deliveryPoint.id} className={classes.deliveryPointChip}>
              <span>
                {deliveryPoint.name} — {deliveryPoint.address.city}
              </span>
              <IconButton size="small" onClick={() => handleRemoveDeliveryPoint(deliveryPoint.id)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
            </div>
          ))}
        </section>
      )}
    </>
  );
}
